import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=3d870275&scoped=true&"
import script from "./Keyword.vue?vue&type=script&lang=js&"
export * from "./Keyword.vue?vue&type=script&lang=js&"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=3d870275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d870275",
  null
  
)

export default component.exports